import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { IconHeartOn16, IconHeartOff16 } from '@cian/ui-kit/icons';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var FavoriteButton = /*#__PURE__*/function (_React$Component) {
  _inherits(FavoriteButton, _React$Component);
  var _super = _createSuper(FavoriteButton);
  function FavoriteButton() {
    _classCallCheck(this, FavoriteButton);
    return _super.apply(this, arguments);
  }
  _createClass(FavoriteButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isActive = _this$props.isActive,
        toggleFavorite = _this$props.toggleFavorite,
        offerId = _this$props.offerId,
        _this$props$theme = _this$props.theme,
        theme = _this$props$theme === void 0 ? 'fill_secondary' : _this$props$theme;
      var icon = isActive ? /*#__PURE__*/_jsx(IconHeartOn16, {
        color: "error_100"
      }) : /*#__PURE__*/_jsx(IconHeartOff16, {
        color: "error_100"
      });
      return /*#__PURE__*/_jsx("div", {
        className: styles['container'],
        children: /*#__PURE__*/_jsx(Button, {
          theme: theme,
          onClick: function onClick() {
            return toggleFavorite(offerId);
          },
          beforeIcon: icon,
          size: "XS",
          children: isActive ? 'В избранном' : 'В избранное'
        })
      });
    }
  }]);
  return FavoriteButton;
}(React.Component);